<template>
  <v-flex class="mx-0 pr-0 ">
    <v-flex xs12 class="add-service-flex mx-0 px-0 ">
      <v-layout row wrap class="mx-0 px-0">
        <v-flex
          xs12
          md4
          lg6
          pt-1
          class="mx-0 px-0"
        >
          <v-text-field
            name="addService"
            type="text"
            v-model="serviceTxt"
            class="pt-0 mt-0 add-service-txt-field"
            @keyup.enter="saveService"
            @blur="!serviceTxt ? (isAddService = false) : ''"
            :placeholder="$t('message.bizgainOnboarding.addProductServices')"
            autocapitalize="off"
          >
            <template v-slot:append>
              <div @click="saveService">
                <v-icon>done</v-icon>
                <span class="append-text">
                  {{ $t('message.bizgainOnboarding.Add') }}
                </span>
              </div>
            </template>

            <template v-if="serviceIcon" v-slot:prepend>
              <v-icon>work_outline</v-icon>
            </template>
          </v-text-field>
        </v-flex>
        <v-flex v-if="$vuetify.breakpoint.lg" lg6 />
        <v-flex
          xs6
          md4
          lg3
          v-for="(newService, index) in newServices"
          :key="index"
        >
          <v-chip class="service-chips">
            <span class="text-ellipsis">
              {{ newService }}
            </span>
            <v-icon
              small
              right
              color="black"
              @click="remove(index)"
            >
              close
            </v-icon>
          </v-chip>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      class="text--disabled caption"
      v-if="serviceSuggestion.length <= 0 && newServices.length <= 0"
    >
      {{ $t('message.bizgainOnboarding.serviceExample') }}
    </v-flex>
    <v-flex
      v-if="
        (newServices.length <= 0 && businessType) || newServices.length <= 0
      "
      class="pt-2"
      lg6
      md6
      xs12
    >
      <v-alert :value="true" type="info" outline>
        {{ $t('message.bizgainOnboarding.atLeastOneServiceShouldBeAdded') }}
      </v-alert>
    </v-flex>
  </v-flex>
</template>
<script>
import { mapGetters } from 'vuex';
import {
  VLayout,
  VFlex,
  VChip,
  VIcon,
  VTextField,
  VAlert
} from 'vuetify/lib';

export default {
  components: {
    VLayout,
    VFlex,
    VChip,
    VIcon,
    VTextField,
    VAlert
  },
  props: ['serviceIcon', 'existingBusinessService'],
  data() {
    return {
      newServices: [],
      serviceSuggestion: [],
      serviceTxt: null,
      businessType: null,
      isServiceUpdate: false
    };
  },
  computed: {
    ...mapGetters(['suggestedServices', 'roimaticConfiguration', 'services'])
  },
  methods: {
    saveService() {
      if (this.serviceTxt && this.serviceTxt.trim()) {
        let serviceExists = this.newServices.findIndex(service => service.toLowerCase() === this.serviceTxt.trim().toLowerCase());
        if(serviceExists === -1)
          this.newServices.push(this.serviceTxt.trim());
        this.$emit('services-update', this.newServices, this.isServiceUpdate = true);
      }
      this.serviceTxt = '';
      this.isAddService = !this.isAddService;
    },
    selectServiceFromSuggestion(suggestionService) {
      var indexOfService = this.newServices.indexOf(suggestionService);
      if (suggestionService && indexOfService === -1) {
        this.newServices.push(suggestionService);
        this.$emit('services-update', this.newServices, this.isServiceUpdate = true);
      } else {
        this.newServices.splice(indexOfService, 1);
        this.$emit('services-update', this.newServices, this.isServiceUpdate = true);
      }
    },
    remove(index) {
      this.newServices.splice(index, 1);
      this.$emit('services-update', this.newServices, this.isServiceUpdate = true);
    },
    populateService(services) {
      this.newServices = [];
      if (services && Array.isArray(services) && services.length > 0) {
        services.forEach((service) => this.newServices.push(service));
        this.$emit('services-update', this.newServices, this.isServiceUpdate = false);
      }
    },
    addServiceSuggestions(services) {
      this.serviceSuggestion = [];
      if (services && Array.isArray(services) && services.length > 0) {
        services.forEach((service) => this.serviceSuggestion.push(service));
      }
    }
  },
  created() {
    this.addServiceSuggestions(this.suggestedServices);
    if(this.existingBusinessService){
      this.populateService(this.roimaticConfiguration.business.services);
    }
    else{
      this.populateService(this.services);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-chip__content {
  width: 100%;
  span {
    display: inline-block;
  }
}

// Text ellipsis
.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}

::v-deep .add-service-flex {
  .layout {
    .flex {
      height: 35px !important;
      .add-service-txt-field {
        max-height: 28px !important;
        .v-input__control {
          .v-input__slot {
            margin-bottom: 0 !important;
            border-bottom: solid 0.5px var(--v-black-base) !important;
            background-color: var(--v-white-base) !important;
            height: 28px !important;
            &::before {
              border-style: none !important;
            }
            &::after {
              border-style: none !important;
            }
            .v-input__append-inner {
              color: var(--v-primary-base) !important;
            }
            .v-text-field__slot {
              input {
                padding: 0 !important;
              }
            }
          }
        }
      }

      .service-chips {
        background-color: var(--v-primary-variation-1-base) !important;
        color: var(--v-black-base) !important;
      }
    }
  }
}

::v-deep .v-alert {
  border-radius: 5px;
  padding: 10px !important;
  color: var(--v-primary-base) !important;
  div {
    color: black !important;
  }
}

::v-deep .v-text-field {
  .v-input__append-inner {
    cursor: pointer;
    .append-text {
      margin: auto;
      position: relative;
      top: -3px;
    }
  }
}

::v-deep .add-service-txt-field {
  @media screen and (max-width: 320px) {
    .v-text-field__slot {
      width: 40px !important;
    }
  }
}
</style>
